var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoLayerTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 761,
    height: 93,
    viewBox: "0 0 761 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8496 14.6523C21.8223 5.51758 11.4668 0 0.349609 0H760.674C749.557 0 739.199 5.51758 733.174 14.6523L691.145 78.3477C685.117 87.4824 674.762 93 663.645 93H97.3789C86.2617 93 75.9043 87.4824 69.877 78.3477L27.8496 14.6523Z",
    fill: "#170C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLayerTop);
export default __webpack_public_path__ + "static/media/video_layer_top.ddbf889e81ac63ba2a233a771dc68e55.svg";
export { ForwardRef as ReactComponent };